module.exports = __webpack_public_path__ + "static/media/avatar.775b91d4.jpg";